/**
 * frappe-ui useCall expects `{ data: T }` but classic Frappe RPC returns `{ message: T }`.
 * Normalize successful /api responses so useCall, resources, etc. work against a real site.
 */
const originalFetch = window.fetch.bind(window)

window.fetch = async function frappeCompatFetch(input, init) {
  const opts = init ? { ...init } : {}
  // Always send cookies to the proxied Frappe backend
  if (opts.credentials == null) {
    opts.credentials = 'include'
  }

  const res = await originalFetch(input, opts)
  const url = typeof input === 'string' ? input : input?.url || ''
  if (!url.includes('/api/')) {
    return res
  }

  // Only rewrite JSON bodies we can parse
  const ctype = res.headers.get('content-type') || ''
  if (!ctype.includes('application/json')) {
    return res
  }

  try {
    const json = await res.clone().json()
    if (json && typeof json === 'object' && !Array.isArray(json)) {
      if (json.message !== undefined && json.data === undefined) {
        json.data = json.message
        return new Response(JSON.stringify(json), {
          status: res.status,
          statusText: res.statusText,
          headers: res.headers,
        })
      }
    }
  } catch {
    // leave original response alone
  }
  return res
}
